// extracted by mini-css-extract-plugin
export default {"select":"AdminGrowingDegreeDaysPage_select__eTaWb"};